module.exports = __webpack_public_path__ + "banquet/containers/MarketingPricingContainer/images/customers.e874ccb851189e934b2723d12da07f54.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/containers/MarketingPricingContainer/images/customers.png
// module id = 1716
// module chunks = 1